import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import "./NumberInput.scss";

type NumberInputProps = {
  onUpdate: (newValue: number | null | string) => void;
  value?: number | null;

  disabled: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
};

const NumberInput: React.FC<NumberInputProps> = ({
  onUpdate,
  value,
  disabled,
  inputRef,
}) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [error, setError] = useState("");
  const intl = useIntl();

  useEffect(() => {
    setInputValue(
      value !== null && value !== undefined ? value.toString() : ""
    );
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Remove all non-numeric characters
    const newValue = event.target.value.replace(/[^0-9]/g, "");

    setInputValue(newValue);

    if (!/^\d*\.?\d*$/.test(newValue)) {
      const errorMessage = intl.formatMessage({
        id: "number-input-error-message",
        defaultMessage: "Number not valid",
      });
      setError(errorMessage);
      onUpdate(newValue);
    } else {
      setError("");
      onUpdate(newValue);
    }
  };

  return (
    <div className="number-input-container">
      <input
        disabled={disabled}
        type="text"
        inputMode="decimal" // for mobile keyboards
        value={inputValue}
        onChange={handleInputChange}
        ref={inputRef}
      />{" "}
      {error && <span className="number-input-container__error">{error}</span>}
    </div>
  );
};

export default NumberInput;
